import $ from 'jquery';

const $btn = $('.emit-create-story');

export function show() {
  $btn.show();
}

export function hide() {
  $btn.hide();
}

export function onClick(cb) {
  $btn.on('click', cb);
}

export function disable() {
  $btn.addClass('button_disabled');
}

export function enable() {
  $btn.removeClass('button_disabled');
}
